import React from "react";
import Back from "../Common/back/Back";
import AboutCard from "./AboutCard";

const About = () => {
	return (
		<div>
			<Back title="Organisation" />
			<AboutCard />
		</div>
	);
};

export default About;
